/* eslint-disable no-undef */
import axios from 'axios';
import axiosRetry from 'axios-retry';

const axiosWithAuto = axios.create({
  headers: {
    ...(typeof companyId !== 'undefined' && companyId && { 'ws-company-id': companyId }),
    ...(typeof authCode !== 'undefined' && authCode && { Authorization: authCode }),
  },
});
// Setup auto retry
axiosRetry(axiosWithAuto, {
  retryDelay: axiosRetry.exponentialDelay,
});

export default axiosWithAuto;
